import { render, staticRenderFns } from "./CrewExperience.vue?vue&type=template&id=33aae6ce&scoped=true"
import script from "./CrewExperience.vue?vue&type=script&setup=true&lang=ts"
export * from "./CrewExperience.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aae6ce",
  null
  
)

export default component.exports